var popoverThemeWeb = {
  background: 'text.primary',
  color: 'background.secondary',
  borderRadius: 'borders.radius',
  container: {
    shadowStyle: 'medium'
  }
};

export { popoverThemeWeb };
